export let SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES = /*#__PURE__*/function (SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES) {
  SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES[SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES["ON_MOUSE_OVER"] = 1] = "ON_MOUSE_OVER";
  SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES[SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES["ALWAYS"] = 2] = "ALWAYS";
  return SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES;
}({});
//# sourceMappingURL=show-expanded-video-list-titles.js.map